import { Components, Theme } from "@mui/material";

/**
 * Hide native number-input spinners (and related WebKit controls) app-wide so
 * quantity flows can rely on custom +/- controls without duplicating CSS.
 */
export const muiInputBase: Components<Omit<Theme, "components">> = {
  MuiInputBase: {
    styleOverrides: {
      input: {
        "&[type=number]": {
          MozAppearance: "textfield"
        },
        "&[type=number]::-webkit-clear-button": {
          display: "none"
        },
        "&[type=number]::-webkit-outer-spin-button, &[type=number]::-webkit-inner-spin-button":
          {
            WebkitAppearance: "none",
            margin: 0
          }
      }
    }
  }
};
